(function () {
    $(function() {
        $(".trusting-companies-slider .slider").slick({
            dots: false,
            infinite: true,
            draggable: false,
            swipe: true,
            autoplay: true,
            speed: 1500,
            slidesToShow: 5,
            slidesToScroll: 5,
            autoplaySpeed: 5e3,
            prevArrow: $('.trusting-companies-slider  .carousel-arrow.left-arrow'),
            nextArrow: $('.trusting-companies-slider  .carousel-arrow.right-arrow'),
            responsive: [
                {
                    breakpoint: 1024,
                    settings: { slidesToShow: 5, slidesToScroll: 5 }
                }, {
                    breakpoint: 992,
                    settings: { slidesToShow: 4, slidesToScroll: 4 }
                }, {
                    breakpoint: 600,
                    settings: { slidesToShow: 3, slidesToScroll: 3 }
                }, {
                    breakpoint: 450,
                    settings: { slidesToShow: 2, slidesToScroll: 2 }
                }
            ]
        });

        $(".faq").click(function () {
            $(this).find(".icon-only").toggleClass("open").toggleClass("closed");
            $(this).find(".faq-body").slideToggle();
        });
    });
})();